// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Include non-_Public Transportation_ `Trip` if a short footpath makes sense between two `StopPlace's`:
 * - NONE: avoid non-_Public Transportation_ `Trip's` at all- STOPPLACE_FOOTPATH: an additional very first `Trip` with one `PersonalLeg might be added if a `Trip` connects two near `StopPlace's`<br>This filter **needs special Grants for a clientId**, if you observe **403 FORRBIDDEN, please ajdust.**<br>This parameter has an impact on performance and/or response volume, set wisely!
 * @export
 */
export const NonPTTripEnum = {
    None: 'NONE',
    StopplaceFootpath: 'STOPPLACE_FOOTPATH'
} as const;
export type NonPTTripEnum = typeof NonPTTripEnum[keyof typeof NonPTTripEnum];


export function instanceOfNonPTTripEnum(value: any): boolean {
    for (const key in NonPTTripEnum) {
        if (Object.prototype.hasOwnProperty.call(NonPTTripEnum, key)) {
            if (NonPTTripEnum[key as keyof typeof NonPTTripEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function NonPTTripEnumFromJSON(json: any): NonPTTripEnum {
    return NonPTTripEnumFromJSONTyped(json, false);
}

export function NonPTTripEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): NonPTTripEnum {
    return json as NonPTTripEnum;
}

export function NonPTTripEnumToJSON(value?: NonPTTripEnum | null): any {
    return value as any;
}

export function NonPTTripEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): NonPTTripEnum {
    return value as NonPTTripEnum;
}

